import { StreamData } from 'types/streamData'
import { WidgetType } from 'enums'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sharesResolver: FieldResolver = (metadata: Metadata) => {
  let shares: string | number | undefined = metadata.getShares()

  if (metadata.getWidgetType() === WidgetType.SOCIAL_WEB_POPULAR_POSTS) {
    shares = metadata.getRetweets()
  }

  return { shares } as StreamData
}

export default sharesResolver
